module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SA - Saudi Arabia.05404f7e.svg";